"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResolverHandler = void 0;
const React = require("react");
const react_1 = require("react");
const ErrorResolver_1 = require("../../../../contexts/ErrorResolver");
const ErrorPlaceholder_1 = require("../../structure/ErrorPlaceholder");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ErrorResolverHandler");
const ErrorResolverHandler = ({ children, variant = "inline" }) => {
    // const errors = useRef<IErrorDescription[]>([]);
    const [errors, setErrors] = (0, react_1.useState)([]);
    const removeError = (0, react_1.useRef)();
    removeError.current = (error) => {
        const i = errors.findIndex(e => e === error);
        if (i !== -1) {
            setErrors(errors.filter((e, j) => j !== i));
        }
    };
    const handleRetry = (0, react_1.useCallback)((error) => {
        if (errors.length === 0)
            return;
        removeError.current(error);
        if (!error.retry)
            return;
        return error.retry();
    }, [errors]);
    // useRef in case someone is holding an old reference at the time of handling the error
    const queueError = (0, react_1.useRef)();
    queueError.current = (e) => {
        // TODO log all errors to somewhere useful
        // throw away silent errors
        if (e.approach === "silent") {
            return;
        }
        setErrors([...errors, e]);
    };
    // this should never change, in case it's being use in a watch block that will cause
    // unwanted updates, e.g. useEffect(() => {...}, [resolveError]) - this will reevaluate
    // any time an error is thrown by another part of the system
    const value = (0, react_1.useMemo)(() => ({
        resolveError: (e) => queueError.current(e)
    }), []);
    const currentError = errors.length && errors[0];
    const showInModal = !!currentError && (currentError.approach || variant) === "modal";
    const hideChildren = !!currentError && (currentError.approach || variant) === "inline";
    const inModalClose = (currentError === null || currentError === void 0 ? void 0 : currentError.hideCloseIcon) === true ? null : () => { };
    return (React.createElement(ErrorResolver_1.ErrorResolverContext.Provider, { value: value },
        !!currentError && (React.createElement(ErrorPlaceholder_1.default, { title: currentError.title, description: currentError.description, showSupportContact: currentError.showSupportContact, canDismiss: currentError.canDismiss, retry: () => handleRetry(currentError), retryLabel: currentError.retry ? "Try again" : "Dismiss", inModal: showInModal, inModalClose: inModalClose })),
        React.createElement("div", { className: css("", { "-hide": hideChildren }) }, children)));
};
exports.ErrorResolverHandler = ErrorResolverHandler;
//# sourceMappingURL=index.js.map